import { render, staticRenderFns } from "./BankDetails.vue?vue&type=template&id=6c90ecaa&scoped=true&"
import script from "./BankDetails.vue?vue&type=script&lang=js&"
export * from "./BankDetails.vue?vue&type=script&lang=js&"
import style0 from "./BankDetails.vue?vue&type=style&index=0&id=6c90ecaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c90ecaa",
  null
  
)

export default component.exports